import { render } from "./PersuasionCharacteristics.vue?vue&type=template&id=56eccc31"
import script from "./PersuasionCharacteristics.vue?vue&type=script&lang=js"
export * from "./PersuasionCharacteristics.vue?vue&type=script&lang=js"
script.render = render

export default script